import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faVideoSlash,
  faListUl,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons"

const variants = {
  "no-videos": {
    icon: faVideoSlash,
    message: "No educational videos assigned to this record yet.",
  },
  "no-selection": {
    icon: faListUl,
    message: "Select a record to see its videos and engagement.",
  },
  "not-found": {
    icon: faMagnifyingGlass,
    message:
      "This record could not be found. It may have been removed, or you may not have access to it.",
  },
}

// The detail pane when there is nothing to detail. `log` is optional — there is
// no record to name in the no-selection case.
const EmptyDetail = ({ log, variant = "no-selection" }) => {
  const { icon, message } = variants[variant] || variants["no-selection"]

  return (
    <div className="h-full flex flex-col items-center justify-center text-center px-8 py-16">
      <FontAwesomeIcon className="w-7 h-7 text-gray-300" icon={icon} />
      {log?.AccessionNo && (
        <p className="mt-4 text-base font-semibold text-gray-800">
          {log.AccessionNo}
        </p>
      )}
      <p className="mt-1 max-w-sm text-sm text-gray-500">{message}</p>
      {log?.CreatedDate && (
        <p className="mt-1 text-xs text-gray-400">
          {new Date(log.CreatedDate).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
        </p>
      )}
    </div>
  )
}

export default EmptyDetail
